/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { addDays, format, lastDayOfMonth, sub, subDays } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import CloseIcon from '@mui/icons-material/Close';
import { 
  ChipsStack,
  Container, 
  DateContainer, 
  DateContent, 
  DividerStyled, 
  FormControlStyled, 
  FormLabelStyled, 
  HeaderDateModal, 
  HeaderTitle, 
  LabelStyled, 
  ModalStyled, 
  PeriodTitle, 
  RadioGroupStyled, 
  RadioStyled, 
  StyledButton, 
  StyledChip, 
  TextFieldStyled, 
} from './styles';


export const DATE_FILTERS = {
  BY_ISSUE_DATE: 'Data de emissão',
  BY_DELIVERY_DATE: 'Data de entrega',
}

export const dateFilterToDays = {
  BY_ISSUE_DATE: 1,
  BY_DELIVERY_DATE: 2,
};

export const periodFilterToDays = {
  LAST_30_DAYS: 30,
  LAST_1_MONTH: 1,
  LAST_2_MONTHS: 2,
  LAST_3_MONTHS: 3,
  LAST_4_MONTHS: 4,
  LAST_6_MONTHS: 6,
};

export const periodFormatted = {
  LAST_30_DAYS: format(
    subDays(new Date(), periodFilterToDays.LAST_30_DAYS),
    'yyyy/MM/dd',
  ),
  LAST_1_MONTH: format(
    sub(new Date(), { months: periodFilterToDays.LAST_1_MONTH }),
    'yyyy/MM/01',
  ),
  LAST_2_MONTHS: format(
    sub(new Date(), { months: periodFilterToDays.LAST_2_MONTHS }),
    'yyyy/MM/01',
  ),
  LAST_3_MONTHS: format(
    sub(new Date(), { months: periodFilterToDays.LAST_3_MONTHS }),
    'yyyy/MM/01',
  ),
  LAST_4_MONTHS: format(
    sub(new Date(), { months: periodFilterToDays.LAST_4_MONTHS }),
    'yyyy/MM/01',
  ),
  CUSTOM: format(new Date(), 'yyyy/MM/dd'),
};

export const PERIOD_FILTERS = {
  CUSTOM: 'custom',
};

const DateFilter = ({
  onApply,
  byDate,
  initialPeriod,
  finalPeriod,
  onBackdropClick
}) => {
  const [selectedItemByEmission, setSelectedItemByEmission] = useState(byDate);

  const initialPeriodFormatted = format(addDays(new Date(initialPeriod), 1), 'yyyy/MM/dd')
  const finalPeriodFormatted = format(addDays(new Date(finalPeriod), 1), 'yyyy/MM/dd')

  const [selectedItemByPeriod, setSelectedItemByPeriod] =
    useState(initialPeriodFormatted);
  const [startDate, setStartDate] = useState(initialPeriodFormatted);
  const [endDate, setEndDate] = useState(finalPeriodFormatted);

  const inputRef = useRef();

  const handleChangeByDate = e => {
    setSelectedItemByEmission(e.target.value);
  };

  const _renderHeader = () => (
    <HeaderDateModal>
      <HeaderTitle>
        Filtrar
      </HeaderTitle>
      <CloseIcon sx={{cursor: 'pointer'}} onClick={onBackdropClick} height={24} htmlColor="#fff" />
    </HeaderDateModal>
  )

  const handleChangeByPeriod = period => {
    if (period === periodFilterToDays.LAST_30_DAYS) {
      setSelectedItemByPeriod(
        periodFormatted.LAST_30_DAYS
      );
      setStartDate(periodFormatted.LAST_30_DAYS);

      setEndDate(format(new Date(), 'yyyy/MM/dd'));
    } else if (period === periodFilterToDays.LAST_1_MONTH) {
      setSelectedItemByPeriod(periodFormatted.LAST_1_MONTH);

      setStartDate(periodFormatted.LAST_1_MONTH)

      setEndDate(format(lastDayOfMonth(new Date(periodFormatted.LAST_1_MONTH)), 'yyyy/MM/dd'));
    } else if (period === periodFilterToDays.LAST_2_MONTHS) {
      setSelectedItemByPeriod(periodFormatted.LAST_2_MONTHS);

      setStartDate(periodFormatted.LAST_2_MONTHS)

      setEndDate(format(lastDayOfMonth(new Date(periodFormatted.LAST_2_MONTHS)), 'yyyy/MM/dd'));
    } else if (period === periodFilterToDays.LAST_3_MONTHS) {
      setSelectedItemByPeriod(periodFormatted.LAST_3_MONTHS);

      setStartDate(periodFormatted.LAST_3_MONTHS)

      setEndDate(format(lastDayOfMonth(new Date(periodFormatted.LAST_3_MONTHS)), 'yyyy/MM/dd'));
    } else if (period === periodFilterToDays.LAST_4_MONTHS) {
      setSelectedItemByPeriod(periodFormatted.LAST_4_MONTHS);

      setStartDate(periodFormatted.LAST_4_MONTHS);

      setEndDate(format(lastDayOfMonth(new Date(periodFormatted.LAST_4_MONTHS)), 'yyyy/MM/dd'));
    }

    if (period === PERIOD_FILTERS.CUSTOM) {
      setSelectedItemByPeriod(PERIOD_FILTERS.CUSTOM);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (selectedItemByPeriod === periodFormatted.LAST_30_DAYS) {
      onApply({
        byDate: selectedItemByEmission,
        initialPeriod: format(
          subDays(new Date(), periodFilterToDays.LAST_30_DAYS),
          'yyyy-MM-dd',
        ),
        finalPeriod: format(new Date(), 'yyyy-MM-dd'),
      });
    } else if (selectedItemByPeriod === periodFormatted.LAST_1_MONTH) {
      onApply({
        byDate: selectedItemByEmission,
        initialPeriod: format(
          sub(new Date(), { months: periodFilterToDays.LAST_1_MONTH}),
          'yyyy-MM-01',
        ),
        finalPeriod: format(lastDayOfMonth(new Date(periodFormatted.LAST_1_MONTH)), 'yyyy-MM-dd'),
      });
    } else if (selectedItemByPeriod === periodFormatted.LAST_2_MONTHS) {
      onApply({
        byDate: selectedItemByEmission,
        initialPeriod: format(
          sub(new Date(), { months: periodFilterToDays.LAST_2_MONTHS}),
          'yyyy-MM-01',
        ),
        finalPeriod: format(lastDayOfMonth(new Date(periodFormatted.LAST_2_MONTHS)), 'yyyy-MM-dd'),
      });
    } else if (selectedItemByPeriod === periodFormatted.LAST_3_MONTHS) {
      onApply({
        byDate: selectedItemByEmission,
        initialPeriod: format(
          sub(new Date(), { months: periodFilterToDays.LAST_3_MONTHS}),
          'yyyy-MM-01',
        ),
        finalPeriod: format(lastDayOfMonth(new Date(periodFormatted.LAST_3_MONTHS)), 'yyyy-MM-dd'),
      });
    } else if (selectedItemByPeriod === periodFormatted.LAST_4_MONTHS) {
      onApply({
        byDate: selectedItemByEmission,
        initialPeriod: format(
          sub(new Date(), { months: periodFilterToDays.LAST_4_MONTHS}),
          'yyyy-MM-01',
        ),
        finalPeriod: format(lastDayOfMonth(new Date(periodFormatted.LAST_4_MONTHS)), 'yyyy-MM-dd'),
      });
    }

    if (selectedItemByPeriod === PERIOD_FILTERS.CUSTOM) {
      onApply({
        byDate: selectedItemByEmission,
        initialPeriod: startDate
          ? format(new Date(startDate), 'yyyy-MM-dd')
          : null,
        finalPeriod: endDate ? format(new Date(endDate), 'yyyy-MM-dd') : null,
      });
    }
  };

  const isCustomSelected = 
    !(selectedItemByPeriod === periodFormatted.LAST_30_DAYS) &&
    !(selectedItemByPeriod === periodFormatted.LAST_1_MONTH) &&
    !(selectedItemByPeriod === periodFormatted.LAST_2_MONTHS) &&
    !(selectedItemByPeriod === periodFormatted.LAST_3_MONTHS) &&
    !(selectedItemByPeriod === periodFormatted.LAST_4_MONTHS);


  return (
    <ModalStyled
      size="small"
      renderHeader={_renderHeader()}
      onBackdropClick={onBackdropClick}
    >
      <div>
        <Container>
          <FormControlStyled>
            <RadioGroupStyled
              defaultValue={
                byDate.length !== 0
                  ? byDate
                  : dateFilterToDays.BY_ISSUE_DATE
              }
              onChange={handleChangeByDate}
            >
              <FormLabelStyled
                value={dateFilterToDays.BY_ISSUE_DATE}
                control={<RadioStyled />}
                label={
                  <LabelStyled component="span">
                    {DATE_FILTERS.BY_ISSUE_DATE}
                  </LabelStyled>
                }
              />
              <FormLabelStyled
                value={dateFilterToDays.BY_DELIVERY_DATE}
                control={<RadioStyled />}
                label={
                  <LabelStyled component="span">
                    {DATE_FILTERS.BY_DELIVERY_DATE}
                  </LabelStyled>
                }
              />
            </RadioGroupStyled>
          </FormControlStyled>
          <DividerStyled />
          <DateContainer>
            <PeriodTitle component="span">Data ou período</PeriodTitle>
            <ChipsStack direction="row" gap={2} marginBottom={3}>
              <StyledChip 
                clickable 
                onClick={() => handleChangeByPeriod(periodFilterToDays.LAST_4_MONTHS)}
                color={selectedItemByPeriod === periodFormatted.LAST_4_MONTHS ? 'secondary' : 'primary' }
                label={
                  format(
                    new Date(periodFormatted.LAST_4_MONTHS),
                    'LLL/yy',
                    { locale: ptBR }
                  )
                } 
              />
              <StyledChip 
                clickable 
                onClick={() => handleChangeByPeriod(periodFilterToDays.LAST_3_MONTHS)}
                color={selectedItemByPeriod === periodFormatted.LAST_3_MONTHS ? 'secondary' : 'primary' }
                label={
                  format(
                    new Date(periodFormatted.LAST_3_MONTHS),
                    'LLL/yy',
                    { locale: ptBR }
                  )
                } 
              />
              <StyledChip 
                clickable 
                onClick={() => handleChangeByPeriod(periodFilterToDays.LAST_2_MONTHS)}
                color={selectedItemByPeriod === periodFormatted.LAST_2_MONTHS ? 'secondary' : 'primary' }
                label={
                  format(
                    new Date(periodFormatted.LAST_2_MONTHS),
                    'LLL/yy',
                    { locale: ptBR }
                  )
                }  
              />
              <StyledChip 
                clickable
                onClick={() => handleChangeByPeriod(periodFilterToDays.LAST_1_MONTH)}
                color={selectedItemByPeriod === periodFormatted.LAST_1_MONTH ? 'secondary' : 'primary' }
                label={
                  format(
                    new Date(periodFormatted.LAST_1_MONTH),
                    'LLL/yy',
                    { locale: ptBR }
                  )
                }  
              />
              <StyledChip 
                clickable
                onClick={() => handleChangeByPeriod(periodFilterToDays.LAST_30_DAYS)}
                color={selectedItemByPeriod === periodFormatted.LAST_30_DAYS ? 'secondary' : 'primary' }
                label="Últimos 30 dias" 
              />
              <StyledChip 
                clickable
                onClick={() => {
                  handleChangeByPeriod(PERIOD_FILTERS.CUSTOM)
                  inputRef.current.focus()
                }}
                color={isCustomSelected ? 'secondary' : 'primary' }
                label="Outro período"
              />
            </ChipsStack>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateContent>
                <DatePicker
                  label="Data de inicio"
                  disableOpenPicker
                  value={ startDate || initialPeriodFormatted }
                  onChange={newValue => {
                    setStartDate(newValue);
                    setSelectedItemByPeriod(PERIOD_FILTERS.CUSTOM);
                  }}
                  renderInput={params => (
                    <TextFieldStyled variant="standard" {...params} />
                  )}
                  inputFormat="dd/MM/yyyy"
                  inputRef={inputRef}
                  
                />

                <DatePicker
                  label="Data de fim"
                  disableOpenPicker
                  value={ endDate || finalPeriodFormatted }
                  onChange={newValue => {
                    setEndDate(newValue);
                    setSelectedItemByPeriod(PERIOD_FILTERS.CUSTOM);
                  }}
                  renderInput={params => (
                    <TextFieldStyled variant="standard" {...params} />
                  )}
                  inputFormat="dd/MM/yyyy"
                />
              </DateContent>
            </LocalizationProvider>
          </DateContainer>
          <StyledButton 
            skin="primary"
            onClick={handleSubmit}
            type="submit"
          >
            Aplicar
          </StyledButton>
        </Container>
      </div>
    </ModalStyled>
  );
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(DateFilter);
